import { Pipe } from '@angular/core';

@Pipe({
    name: "phone",
    standalone: false
})
export class PhonePipe {
  transform(rawNum: string | null): string{
    if(!rawNum){
      return '';
    }
    let formattedPhone = rawNum;
    if(rawNum.length >= 10)
    {
      formattedPhone = rawNum.slice(0,3) + '-' + rawNum.slice(3,6) + '-' + rawNum.slice(-4);
    }
    if(rawNum.length == 7)
    {
      formattedPhone = rawNum.slice(0,3) + '-' + rawNum.slice(3,7);
    }
    return formattedPhone;
  }
}
